// Linework stand-in for the "Roman bust" anchor image on the Landing screen.
// Per the brief I don't hand-draw figurative SVG — this is an explicitly
// marked placeholder with the correct proportions and visual weight so layout
// decisions are accurate. The "single-line drawing" caption keeps the team
// honest about what's stand-in vs. final art.
//
// Ported from handoff_input/design/screens/shared.jsx :: ICSBustPlaceholder.

import { cn } from "@/lib/utils";

export interface BustPlaceholderProps {
  height?: number;
  className?: string;
}

export function BustPlaceholder({
  height = 240,
  className,
}: BustPlaceholderProps) {
  return (
    <div
      className={cn("relative flex w-full items-center justify-center", className)}
      style={{ height }}
    >
      <svg
        viewBox="0 0 200 240"
        width="auto"
        height={height}
        aria-hidden="true"
        className="block"
      >
        <defs>
          <pattern
            id="ics-stripe"
            width="6"
            height="6"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(135)"
          >
            <line x1="0" y1="0" x2="0" y2="6" stroke="#E6E0D2" strokeWidth="3" />
          </pattern>
        </defs>
        {/* Abstract pedestal + head silhouette */}
        <ellipse cx="100" cy="100" rx="46" ry="58" fill="url(#ics-stripe)" />
        <path
          d="M62 150 Q100 130 138 150 L150 200 L50 200 Z"
          fill="url(#ics-stripe)"
        />
        <rect x="40" y="200" width="120" height="14" fill="url(#ics-stripe)" />
      </svg>
      <div
        className="absolute bottom-1 left-1/2 -translate-x-1/2 rounded-[3px] bg-paper px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.4px] text-ink-faint"
      >
        roman bust · single-line drawing
      </div>
    </div>
  );
}
